import { CloseStreamParams as KmmCloseStreamParams } from '@norlys-a-s/norlys-play-kmm';
import { removePersistentData } from '@smart-tv/utils/persistent-data/persistent-data';
import { kmm } from './kmm';

interface CloseStreamParams {
  sid?: number;
  progress?: number;
  mediaId?: number;
  eventId?: number;
}

const toKmmCloseStreamParams = (params: CloseStreamParams): KmmCloseStreamParams => {
  const { sid, progress = 0, mediaId, eventId } = params;

  if (mediaId) {
    return new KmmCloseStreamParams.OnDemandStreamParams(mediaId, progress, false);
  }

  if (sid && eventId) {
    return new KmmCloseStreamParams.ChannelEventStreamParams(sid, eventId, progress, false);
  }

  return new KmmCloseStreamParams.ChannelLiveStreamParams(sid ?? 0);
};

export const closeStream = async (params: CloseStreamParams): Promise<boolean> => {
  const closeStreamParams = toKmmCloseStreamParams(params);

  const result = await kmm((repo) => repo.api.closeStreamUrl(closeStreamParams), false);

  if (result) {
    removePersistentData('active-stream-set');
  }

  return result;
};

export default closeStream;
